import React from 'react'
import estudanteimg from '../../../../assets/Group 10.png'
import './style.css'
import CardInfo from '../../../../components/CardInfo'
import cap from '../../../../assets/graduation-cap-solid.svg'
import classe from '../../../../assets/class.svg'

export default function Info3() {

    const title = 'Ensinando habilidades para o mercado de trabalho'
    const info1 = 'Ensinamos habilidades com foco na prática, preparando nossos alunos para os desafios do mercado. Ajudamos a construir novos caminhos profissionais.'

    const phoneNumber = "5531996092454";

    const openWhatsApp = () => {
        window.open(`https://wa.me/${phoneNumber}`, "_blank");
    };

    return (
        <div className='containerhome1'>
            <div className='containerhome1' style={{ height: '500px' }}>

                <div className='home1left'>

                    <h1 className='tituloInfohome1'><b>{title}</b></h1>
                    <div style={{ marginTop: '20px' }}>

                        <div className='linha' style={{ marginBottom: '20px' }}></div>
                        <h3 className='infohome1'>{info1}</h3>
                        <div className='linha' style={{ marginTop: '20px' }}></div>
                    </div>
                    <h2>Não possui carteira de estudante?</h2>
                    <button onClick={openWhatsApp} >SOLICITAR AGORA</button>
                </div>
                <div className='home1right'>
                    <div style={{ position: 'absolute', top: '50px', left: '20px' }}>
                        <CardInfo icon={cap} text={'Cursos'} title={3} />
                    </div>
                    <div style={{ position: 'absolute', top: '150px', right: '20px' }}>
                        <CardInfo icon={classe} text={'Estudantes'} title={'15K+'} />
                    </div>
                    <img src={estudanteimg} />
                </div>
            </div>
        </div>
    )
}
